import { createPageApp } from '@/lib/createPageApp'
import PurchaseSeminarPage from './PurchaseSeminarPage.vue'

createPageApp(PurchaseSeminarPage).mount()
